import o from "../hooks/useGlobals.js";

import s from "../hooks/useFieldSubscription.js";

const t = o => o.intendedTs, r = () => {
    const {model: r, formatters: e} = o(), n = s(r, t);
    return e.YearAndMonth.format(n);
};

export { r as default };
//# sourceMappingURL=MonthYearLabel.js.map
